import { render, staticRenderFns } from "./ReviewSection.vue?vue&type=template&id=9d2129e4&scoped=true&"
import script from "./ReviewSection.vue?vue&type=script&lang=js&"
export * from "./ReviewSection.vue?vue&type=script&lang=js&"
import style0 from "./ReviewSection.vue?vue&type=style&index=0&id=9d2129e4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d2129e4",
  null
  
)

export default component.exports